/** Base URL for backend API requests. Set via NEXT_PUBLIC_API_URL at build time. */
export const API_URL: string | undefined = process.env.NEXT_PUBLIC_API_URL;

/** WebSocket connection URL for real-time updates. Set via NEXT_PUBLIC_WEBSOCKET_URL at build time. */
export const WEBSOCKET_URL: string | undefined = process.env.NEXT_PUBLIC_WEBSOCKET_URL;

/** Public frontend URL for constructing absolute links. Set via NEXT_PUBLIC_FRONTEND_URL at build time. */
export const FRONTEND_URL: string | undefined = process.env.NEXT_PUBLIC_FRONTEND_URL;

/** Document action path for review flows. */
export const ASPECT_REVIEW: string = '/doc/act/review';

/** Document action path for question flows. */
export const ASPECT_QUESTION: string = '/doc/act/question';

if (!process.env.NEXT_PUBLIC_API_URL) {
  if (process.env.NODE_ENV === 'development') {
    throw new Error(
      'Missing NEXT_PUBLIC_API_URL environment variable; frontend API requests will fail.'
    );
  } else {
    console.error(
      'Missing NEXT_PUBLIC_API_URL environment variable; frontend API requests may fail.'
    );
  }
}
